@import '../variables.module.less';

.pageTitle {
  padding: 0 20px;

  .title {
    font-family: @font-display;
    font-size: 34px;
    font-weight: 500;
    color: @v2-color-primary;
    margin: 0 0 6px;
    line-height: 1.081;
  }

  .subtitle {
    font-size: 14px;
    font-weight: 500;
    color: @v2-color-secondary;
    margin: 0;
    letter-spacing: 0.7px;
  }
}
